/*
 * Uygulama içi gezinme: tam sayfa yüklemesi (window.location.href / düz <a href>) yerine router geçmişi.
 * Tam yükleme paketi, oturum/konfig isteklerini ve açılış verilerini baştan çeker; SPA geçişi yalnız
 * hedef sayfanın kendi verisini yükler.
 *
 * Modal içerikleri (core/components/Modal) Router'ın DIŞINDA render edildiği için orada useHistory
 * çalışmaz. Router içindeki NavigationBridge geçmiş nesnesini buraya kaydeder; navigate() her yerden
 * (modal, servis, olay işleyicisi) çağrılabilir.
 */

let routerHistory = null

export const setRouterHistory = (history) => {
    routerHistory = history
}

export const navigate = (path, { replace = false } = {}) => {
    // Köprü henüz kurulmadıysa (ör. Router dışı ayrı giriş noktası) eski davranış.
    if (!routerHistory) {
        window.location.href = path
        return
    }
    if (replace) routerHistory.replace(path)
    else routerHistory.push(path)
}

/** Orta tık / Ctrl(⌘)+tık / Shift+tık: tarayıcı yeni sekme/pencere açsın, SPA'ya çevirme. */
export const isModifiedClick = (e) =>
    !!e && (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)
